// extracted by mini-css-extract-plugin
export default {"bar":"CostBasisToggle_bar__YY18+","btn":"CostBasisToggle_btn__s92Ho","btnActive":"CostBasisToggle_btnActive__HuUbj"};